module.exports = __webpack_public_path__ + "img/telekom-white.06a1d8cc.png";